import React from "react";
import { Link } from "react-router-dom";
const Card2 = ({ data }) => {
  return (
    <Link to={`/NewsDetails/${data.id}`}>
      <div className="img_wrapper">
        <div className="img-bg">
          <img src="/images/5555.jpg" alt="" className="rounded" />
        </div>
        <h6 className="article_title text-white img-fluid">{data.title}</h6>
      </div>
    </Link>
  );
};

export default Card2;
